import Dropdown from "app/components/Dropdown";
import PlusIcon from "app/components/Icons/PlusIcon";
import CustomTooltip from "app/components/Tooltip";
import { StatusIcon } from "app/components/Icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTicketGroups } from "../../../Tickets/redux/selector";
import { actions } from "../../../Tickets/redux/slice";
import { selectBoardForm } from "../../../../components/Settings/redux/selector";
import { GroupByTypeEnum } from "../../../../types";
import { formatLabel } from "../../../../helpers";
import AddTicketGroupModal from "../AddTicketGroupModal";

interface AddBoardProps {}

const AddHiddenGroup: React.FC<AddBoardProps> = ({}) => {
  const [isGroupModalOpen, setIsGroupModalOpen] = React.useState(false);
  const [isEditGroup, setIsEditGroup] = React.useState(false);
  const dispatch = useDispatch();
  const groupData = useSelector(selectTicketGroups);
  const boardFrom = useSelector(selectBoardForm);
  const hideData = groupData.filter((x) => x?.isHidden);
  const handleUnCollapsed = (group) => {
    dispatch(actions.toggleGroupsIsHidden(group));
  };

  const MenuItems = hideData?.map((ele) => {
    if (ele)
      return {
        label: (
          <div
            className={`flex items-center justify-between gap-2 h-[40px] w-full`}
          >
            <div className="flex items-center gap-3">
              <div className="min-w-[20px]">
                {/* <img
                  src={getTicketIcon(ele?.icon as TicketType)}
                  alt="task-icon"
                  className="size-[24px]"
                /> */}
                <StatusIcon size={20} color={ele?.color} />
              </div>
              <div
                className=" text-sm font-normal truncate"
                style={{ color: ele?.color }}
              >
                {ele?.groupName}
              </div>
            </div>
          </div>
        ),
        action: () => {
          handleUnCollapsed && handleUnCollapsed(ele);
        },
      };
    else return { label: "", action: () => {} };
  });

  return (
    <React.Fragment>
      {boardFrom?.groupBy === GroupByTypeEnum.CUSTOM_TITLES ||
      hideData?.length ? (
        <Dropdown
          trigger={
            <button className="bg-white border border-[#E9ECF2] rounded-[6px] p-[13px] hover:bg-[#ECEEF2]  flex justify-center items-center border border-[#E9ECF2] h-[max-content] ">
              <CustomTooltip
                text={
                  boardFrom?.groupBy === GroupByTypeEnum.CUSTOM_TITLES
                    ? "Add group"
                    : "Add hidden group(s)"
                }
                contentClassName="p-[10px]"
                className=" rounded-[6px] hover:bg-[#ECEEF2] h-[max-content] text-start flex justify-center items-center"
                position="bottom"
              >
                <PlusIcon size={20} color="#79808A" />
              </CustomTooltip>
            </button>
          }
          projectInfoIcon={
            <React.Fragment>
              <div
                className={`${
                  hideData?.length > 0 ? " border-b " : ""
                } flex flex-col  border-[#E9ECF2]`}
              >
                {boardFrom?.groupBy === GroupByTypeEnum.CUSTOM_TITLES && (
                  <button
                    className="flex items-center gap-2 min-h-[40px] w-full text-secondary text-sm font-medium  hover:bg-[#F4F5F7] p-4"
                    onClick={() => {
                      setIsGroupModalOpen(true);
                    }}
                  >
                    <PlusIcon color="#79808A" size={20} />
                    New group
                  </button>
                )}
                <div className="flex flex-col px-4 mb-2 ">
                  <span className="text-secondary text-sm font-medium">
                    Hidden group(s)
                  </span>
                  <span className="text-[10px] font-normal text-secondary leading-[13px]">
                    {hideData?.length > 0
                      ? `By clicking on ${formatLabel(
                          boardFrom?.groupBy
                        )} it will be returned to the board`
                      : "There are no hidden group(s)"}
                  </span>
                </div>
              </div>
            </React.Fragment>
          }
          menuItems={MenuItems ?? []}
          dropDownClassName=" !hover:bg-[#F4F5F7] "
          className={` py-2 rounded border border-[#E9ECF2] max-w-[260px] `}
        />
      ) : (
        <></>
      )}
      {isGroupModalOpen && (
        <AddTicketGroupModal
          onClose={() => setIsGroupModalOpen(false)}
          isEditGroup={isEditGroup}
          modalClassName=" z-[99999999] "
          insetClassName=" z-[99999] "
        />
      )}
    </React.Fragment>
  );
};

export default AddHiddenGroup;
